// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1QHCo","search":"Settings_search__2ZdMD","filter":"Settings_filter__11KzZ"};